import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField'
import Select from 'react-select'
import Axios from 'axios'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'
import server from '../variables'

const BillModal = ({ show, handleClose, consumerID, schemeID, editData, fetchBill }) => {
  const notyf = new Notyf()
  const [bill, setBill] = useState(editData || {})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setBill(editData || {})
  }, [editData])

  const handleInpChange = (e) => {
    setBill({ ...bill, [e.target.name]: e.target.value, consumerID })
  }

  const meterStatusOptions = [
    { label: 'Working', value: true },
    { label: 'Not Working', value: false },
  ]

  const handleMeterStatusChange = (option) => {
    setBill({ ...bill, working: option.value })
  }

  const submitBill = async (e) => {
    e.preventDefault()

    const requiredFields = ['dueDate', 'currentMeterReading', 'fixedCharges', 'otherCharges', 'totalAmountPayable', 'penalty']

    for (let field of requiredFields) {
      if (!bill[field]) {
        notyf.error('Please fill all required fields!')
        return
      }
    }

    setIsLoading(true)
    try {
      const endpoint = editData ? 'admin/update-bill' : 'admin/new-bill'
      const { data } = await Axios.post(`${server}${endpoint}`, bill, {
        headers: { authorization: localStorage.getItem('token') },
      })

      if (data.status === 200) {
        notyf.success(`Bill ${editData ? 'updated' : 'created'} successfully!`)
        fetchBill()
        handleClose()
      } else if (data.status === 410) {
        window.location.href = '/'
      } else {
        notyf.error(data.message)
      }
    } catch (err) {
      console.error(err)
      notyf.error('Internal Server Error!')
    } finally {
      setIsLoading(false)
    }
  }

  if (!show) return null

  return (
    <div className="modal show fade" style={{ display: 'block' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{editData ? 'Edit Bill' : 'Add New Bill'}</h5>
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={submitBill}>
              <div className="row g-3">
                <div className="col-md-6">
                  <TextField label="Due Date" type="date" name="dueDate" value={bill.dueDate || ''} onChange={handleInpChange} InputLabelProps={{ shrink: true }} fullWidth required />
                </div>
                <div className="col-md-6">
                  <TextField label="Current Meter Reading" type="number" name="currentMeterReading" value={bill.currentMeterReading || ''} onChange={handleInpChange} fullWidth required />
                </div>
                <div className="col-md-6">
                  <TextField label="Penalty" type="number" name="penalty" value={bill.penalty || ''} onChange={handleInpChange} fullWidth required />
                </div>
                <div className="col-md-6">
                  <TextField label="Fixed Charges" type="number" name="fixedCharges" value={bill.fixedCharges || ''} onChange={handleInpChange} fullWidth required />
                </div>
                <div className="col-md-6">
                  <TextField label="Other Charges" type="number" name="otherCharges" value={bill.otherCharges || ''} onChange={handleInpChange} fullWidth required />
                </div>
                <div className="col-md-6">
                  <TextField label="Total Amount Payable" type="number" name="totalAmountPayable" value={bill.totalAmountPayable || ''} onChange={handleInpChange} fullWidth required />
                </div>
                <div className="col-md-6">
                  <Select placeholder="Meter Status" options={meterStatusOptions} value={bill.working ? { label: 'Working', value: true } : { label: 'Not Working', value: false }} onChange={handleMeterStatusChange} />
                </div>
                <div className="col-md-6">
                  <TextField label="Connection Charges" type="number" name="connectionCharges" value={bill.connectionCharges || ''} onChange={handleInpChange} fullWidth />
                </div>
                <div className="col-md-6">
                  <TextField label="Arrear Amount" type="number" name="arrearAmount" value={bill.arrearAmount || ''} onChange={handleInpChange} fullWidth />
                </div>
                <div className="col-md-6">
                  <TextField label="Interest On Arrear" type="number" name="intrestOnArrear" value={bill.intrestOnArrear || ''} onChange={handleInpChange} fullWidth />
                </div>
                <div className="col-md-6">
                  <TextField label="Write Off Amount" type="number" name="writeOffAmount" value={bill.writeOffAmount || ''} onChange={handleInpChange} fullWidth />
                </div>
                <div className="col-md-6">
                  <TextField label="Adjust Amount" type="number" name="adjustAmount" value={bill.adjustAmount || ''} onChange={handleInpChange} fullWidth />
                </div>
                <div className="col-md-6">
                  <TextField label="Consume Amount" type="number" name="consumeAmount" value={bill.consumeAmount || ''} onChange={handleInpChange} fullWidth />
                </div>
              </div>
              <div className="mt-4 d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>
                <button type="submit" className="btn btn-primary" disabled={isLoading}>{isLoading ? 'Saving...' : editData ? 'Update Bill' : 'Create Bill'}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BillModal